import { Stack, StackItem, Text } from "@fluentui/react";
import { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import ActionBarComponent from "../components/General/ActionBarComponent/ActionBarComponent";
import Header from "../components/General/Header";
import { RoleContext, TeamLeaderContext } from "../components/General/Layout";
import "../styles/custom.css";
import { useTitle } from "../helpers/useTitle";

const ParkingManagementPage = () => {
  const history = useHistory();
  const { t, i18n } = useTranslation();
  useTitle("Parking management ");

  const isTeamLeader = useContext(TeamLeaderContext);
  const roles = useContext(RoleContext);

  const hasRole = useCallback(
    (role) => {
      return roles?.filter((r) => r.role.name === role).length > 0;
    },
    [roles]
  );

  useEffect(() => {
    if (!hasRole("Permission Manager") && !isTeamLeader)
      history.push("/nopermission");
  }, [roles]);

  return (
    <>
      <ActionBarComponent
        id="action-bar"
        actions={[
          {
            key: "viewOrRemove",
            text: t("sidebar.viewRemove"),
            icon: "",
            primary: true,
            action: () => history.push("/parkingmanagement/view-remove"),
            disabled: false,
            leader: true,
          },
          {
            key: "parkingPermissions",
            text: t("sidebar.parkPermission"),
            icon: "",
            primary: true,
            action: () => history.push("/parkingmanagement/parkingpermissions"),
            disabled: false,
          },
          {
            key: "manageParkingReservations",
            text: t("sidebar.manageReservation"),
            icon: "",
            primary: true,
            action: () =>
              history.push("/parkingmanagement/manageparkingreservations"),
            disabled: false,
            leader: true,
          },
          {
            key: "manageParkingFloorplans",
            text: t("sidebar.manageParkingFloorplans"),
            icon: "",
            primary: true,
            action: () => history.push("/parkingmanagement/floorplans"),
            disabled: false,
          },
          {
            key: "permanentParking",
            text: t("sidebar.permanent"),
            icon: "",
            primary: true,
            action: () => history.push("/parkingmanagement/permanentparking"),
            disabled: false,
          },
        ].filter((button) =>
          hasRole("Permission Manager") ? true : button.leader
        )}
      />
      <Stack
        style={{ marginTop: 30 }}
        tokens={{ childrenGap: 40 }}
        className="page"
      >
        <Header text={t("sidebar.parkManage")} />
        <StackItem style={{ maxWidth: "900px" }}>
          <h5 style={{ paddingBottom: 15 }}>{t("sidebar.viewRemove")}</h5>
          <Text>{t("parkingManagement.viewOrRemove")}</Text>
        </StackItem>
        <StackItem style={{ maxWidth: "900px" }}>
          <h5 style={{ paddingBottom: 15 }}>{t("sidebar.parkPermission")}</h5>
          <Text>{t("parkingManagement.parkPermission")}</Text>
        </StackItem>
        <StackItem style={{ maxWidth: "900px" }}>
          <h5 style={{ paddingBottom: 15 }}>
            {t("sidebar.manageReservation")}
          </h5>
          <Text>{t("parkingManagement.manageReservation")}</Text>
        </StackItem>
        <StackItem style={{ maxWidth: "900px" }}>
          <h5 style={{ paddingBottom: 15 }}>
            {t("sidebar.manageParkingFloorplans")}
          </h5>
          <Text>{t("parkingManagement.manageParkingFloorplans")}</Text>
        </StackItem>
        <StackItem style={{ maxWidth: "900px" }}>
          <h5 style={{ paddingBottom: 15 }}>{t("sidebar.permanent")}</h5>
          <Text>{t("parkingManagement.permanentParking")}</Text>
        </StackItem>
      </Stack>
    </>
  );
};

export default ParkingManagementPage;
